<template>
  <div class="main_box">
    <div class="main_bar">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">投票配置</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div
      class="main_body"
      v-loading="loading"
      :element-loading-text="$config.loadingText"
      :element-loading-spinner="$config.loadingSpinner"
      :element-loading-background="$config.loadingBackground"
    >
      <div class="form_bar">
        <div class="form_bar_search"></div>
        <div class="form_bar_btn">
          <el-button
            type="primary"
            @click="editVoteSetting('settingForm', false)"
            size="small"
            plain
          >
            保存
          </el-button>
        </div>
      </div>
      <div class="form_content">
        <el-form
          :model="settingForm"
          :rules="settingFormRules"
          ref="settingForm"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-divider
            content-position="center"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 2"
          >
            投票按钮设置
          </el-divider>
          <br />
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 2"
          >
            <el-col :span="24">
              <el-form-item
                class="el-form-item-internal"
                v-for="(button, buttonIndex) in settingForm.VoteButtonSetting"
                :key="buttonIndex"
              >
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 24 }"
                  :lg="{ span: 24 }"
                  :xl="{ span: 24 }"
                >
                  <el-form-item
                    label="投票按钮文本："
                    label-width="200px"
                    :prop="'VoteButtonSetting.' + buttonIndex + '.value'"
                    :rules="{
                      required: true,
                      message: '投票按钮文本不能为空',
                      trigger: 'blur'
                    }"
                  >
                    <el-input
                      v-model="button.value"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 24 }"
                  :lg="{ span: 24 }"
                  :xl="{ span: 24 }"
                >
                  <el-form-item
                    label="是否验证投票数目："
                    label-width="200px"
                    prop="isCheckMaxMin"
                  >
                    <el-switch v-model="button.isCheckMaxMin"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 24 }"
                  :lg="{ span: 24 }"
                  :xl="{ span: 24 }"
                >
                  <el-form-item
                    label="最大票数："
                    label-width="200px"
                    prop="maxNum"
                  >
                    <el-input-number
                      v-model="button.maxNum"
                      :step="1"
                      :prop="'VoteButtonSetting.' + buttonIndex + '.maxNum'"
                      :rules="{
                        required: true,
                        message: '最大票数不能为空',
                        trigger: 'blur'
                      }"
                      :disabled="!button.isCheckMaxMin"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 24 }"
                  :lg="{ span: 24 }"
                  :xl="{ span: 24 }"
                >
                  <el-form-item
                    label="最小票数："
                    label-width="200px"
                    prop="minNum"
                  >
                    <el-input-number
                      v-model="button.minNum"
                      :step="1"
                      :prop="'VoteButtonSetting.' + buttonIndex + '.minNum'"
                      :rules="{
                        required: true,
                        message: '最小票数不能为空',
                        trigger: 'blur'
                      }"
                      :disabled="!button.isCheckMaxMin"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-divider
            content-position="center"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 2"
          >
            搜索设置
          </el-divider>
          <br />
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :lg="{ span: 24 }"
              :xl="{ span: 24 }"
            >
              <el-form-item
                label="是否显示搜索功能："
                label-width="200px"
                prop="IsShowSearch"
                required
              >
                <el-switch v-model="settingForm.IsShowSearch"></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :lg="{ span: 24 }"
              :xl="{ span: 24 }"
            >
              <el-form-item
                label="搜索提示语："
                label-width="200px"
                prop="SearchPlaceholder"
                required
              >
                <el-input
                  v-model="settingForm.SearchPlaceholder"
                  autocomplete="off"
                  placeholder="请输入搜索提示语"
                  :disabled="!settingForm.IsShowSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
import voteSettingApi from '../../../../api/vote/voteSetting'
export default {
  name: 'EditVoteSetting',
  data () {
    return {
      meetingId: null,
      voteId: null,
      loading: true,
      settingForm: {
        VoteButtonSetting: [],
        AllSelectConfig: {},
        VoteSubmitConfig: {},
        VoteResetConfig: {},
        VotePreviewConfig: {}
      },
      settingFormRules: {
        ProjectTitle: [
          { required: true, message: '请输入项目显示名称', trigger: 'blur' },
          { min: 1, max: 50, message: '显示名称长度最多100个字符。', trigger: 'blur' }],
        VoterTitle: [
          { required: true, message: '请输入投票人员显示名称', trigger: 'blur' },
          { min: 1, max: 50, message: '显示名称长度最多100个字符。', trigger: 'blur' }],
        VoteMessageConfig: [
          { min: 0, max: 1000, message: '提示信息长度最多1000个字符。', trigger: 'blur' }],
        ResetDefault: [
          { required: true, message: '请输入投票默认值', trigger: 'blur' }],
        'VoteSubmitConfig.textValue': [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        'VoteSubmitConfig.value': [
          { required: true, message: '请输入提示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '提示文本长度最多10个字符。', trigger: 'blur' }],
        'VoteResetConfig.textValue': [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        'VoteResetConfig.value': [
          { required: true, message: '请输入提示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '提示文本长度最多10个字符。', trigger: 'blur' }],
        'AllSelectConfig.allValue': [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        'AllSelectConfig.value': [
          { required: true, message: '请输入提示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '提示文本长度最多10个字符。', trigger: 'blur' }],
        'AllSelectConfig.key': [
          { required: true, message: '请输入全选值', trigger: 'blur' }]
      },
      dialogFormVisible: false,
      btnForm: {},
      editIndex: null,
      btnFormRules: {
        key: [
          { required: true, message: '请输入数值', trigger: 'blur' }],
        value: [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        maxNum: [
          { required: true, message: '请输入最大投票数', trigger: 'blur' }],
        minNum: [
          { required: true, message: '请输入最小投票数', trigger: 'blur' }],
        color: [
          { required: true, message: '请输入字体颜色', trigger: 'blur' }]
      },
      voteInfo: {
        Status: null
      },
      projectTitles: [
        { value: '项目数' },
        { value: '表决数' },
        { value: '表决项' },
        { value: '候选人' },
        { value: '议程数' },
        { value: '评测对象' },
        { value: '被考核人' },
        { value: '被测评人' }],
      voterTitles: [
        { value: '评委数' },
        { value: '代表数' },
        { value: '评测人' },
        { value: '考核人' },
        { value: '投票人' }]
    }
  },
  props: ['meetingInfo'],
  inject: ['voteCheck', 'routeChange', 'getMeetingVoteInfo'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getVoteInfo: function () {
      this.loading = true
      if (this.$route.params.vid !== '0') {
        voteManageApi.getVoteDetail({
          voteId: this.$route.params.vid
        }).then(data => {
          this.voteInfo = data
          this.getVoteSetting()
        }).catch(err => {
          this.loading = false
          return err
        })
      } else {
        this.voteInfo.Status = 0
        this.loading = false
      }
    },
    getVoteSetting: function () {
      const _this = this
      _this.loading = true
      voteSettingApi.getVoteSetting({ voteId: _this.voteId }).then(data => {
        _this.settingForm = data
        _this.settingForm.ResetDefault = _this.settingForm.ResetDefault + ''
        _this.loading = false
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    editVoteSetting: function (formName, isFinish) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          voteSettingApi.editVoteSetting(this.settingForm).then(data => {
            this.getVoteSetting()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            if (isFinish) {
              this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
            }
          }).catch(err => {
            this.loading = false
            return err
          })
        } else {
          return false
        }
      })
    },
    handleEdit: function (index, row) {
      this.btnForm = JSON.parse(JSON.stringify(row))
      this.editIndex = index
      this.dialogFormVisible = true
    },
    handleDelete: function (index, row) {
      const _this = this
      _this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        _this.loading = true
        _this.settingForm.VoteButtonSetting.splice(index, 1)
        _this.settingForm.VoteButtonSetting.forEach((item, index) => {
          item.key = index
        })
        _this.$message({
          type: 'success',
          message: '删除成功!',
          customClass: 'custom_message'
        })
        _this.loading = false
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    addBtn: function () {
      this.btnForm = {}
      this.btnForm.key = this.settingForm.VoteButtonSetting.length
      this.editIndex = null
      this.dialogFormVisible = true
    },
    editBtnConfig: function (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.loading = true
          if (_this.editIndex != null) {
            this.settingForm.VoteButtonSetting.splice(_this.editIndex, 1, JSON.parse(JSON.stringify(_this.btnForm)))
          } else {
            _this.settingForm.VoteButtonSetting.push(JSON.parse(JSON.stringify(_this.btnForm)))
          }
          _this.editVoteSetting('settingForm', false)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    queryProjectTitleSearch (queryString, cb) {
      cb(this.projectTitles)
    },
    projectTitleHandleSelect (item) {
      // console.log(this.settingForm.ProjectTitle)
    },
    queryVoterTitleSearch (queryString, cb) {
      cb(this.voterTitles)
    },
    voterTitleHandleSelect (item) {
      // console.log(this.settingForm.ProjectTitle)
    },
    realTimeSaveResultChange: function () {
      const _this = this
      if (!_this.settingForm.IsRealTimeSaveResult) {
        _this.settingForm.IsRecordVoteDetails = true
      }
    }
  },
  created () {
    this.voteId = this.$route.params.vid
    this.getVoteInfo()
    this.routeChange()
    this.voteCheck()
  }
}
</script>
<style lang="less">
.el-divider--horizontal {
  margin: 15px 0px;
}
</style>
